import state from './state';

/**
 * Displays an error message at the top of the page using the <mw-errors /> component.
 * @param {*} errors - The errors to pass to the <mw-errors /> component.
 * @returns {void}
 */
export default (errors) => {
    state.errors = errors;
    window.scrollTo(0, 0);
};
